import { render } from "./PriceSection.vue?vue&type=template&id=036fbb68&scoped=true"
import script from "./PriceSection.vue?vue&type=script&lang=js"
export * from "./PriceSection.vue?vue&type=script&lang=js"

import "./PriceSection.vue?vue&type=style&index=0&id=036fbb68&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036fbb68"]])

export default __exports__